// extracted by mini-css-extract-plugin
export default {"mainComponent":"dealSummary_mainComponent__dtY9K"};